import { splitProps, type ComponentProps, type VoidComponent } from "solid-js";
import { Icon } from "../icon/Icon";
import Text from "../text/Text";

type InformationButtonProps = {
  text: string;
} & ComponentProps<"button">;

export const InformationButton: VoidComponent<InformationButtonProps> = (props) => {
  const [localProps, otherProps] = splitProps(props, ["text"]);
  return (
    <button
      type="button"
      {...otherProps}
      class="flex min-w-0 items-center gap-0.5 rounded-sm px-1.5 py-1 text-small-medium text-button-text-tertiary-default open:bg-button-bg-tertiary-active hover:bg-button-bg-tertiary-hover focus-visible:outline active:bg-button-bg-tertiary-pressed"
    >
      <Icon
        name="informationCircle"
        size="xs"
        type="outline"
        class="shrink-0 stroke-3 icon-button-icon-tertiary-default"
      />
      <Text text={localProps.text} as="span" truncate />
    </button>
  );
};
